import Vue from 'vue'
import App from './App.vue'
import store from './store'
import './registerServiceWorker'
import router from './router'
import api from './api'
import VueCookies from 'vue-cookies'
export const bus = new Vue();
import vuetify from "./plugins/vuetify";
import Login from './layouts/Login'
import Application from './layouts/Application'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueApexCharts from 'vue-apexcharts'
import ReactiveSearch from '@appbaseio/reactivesearch-vue'

import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Maps from 'fusioncharts/fusioncharts.maps'
import World from 'fusioncharts/maps/fusioncharts.world'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

import Highcharts from "highcharts";
import WordCloud from "highcharts/modules/wordcloud";
import HighchartsVue from "highcharts-vue";
import highchartsMoreInit from "highcharts/highcharts-more";

WordCloud(Highcharts);
highchartsMoreInit(Highcharts);
Vue.use(HighchartsVue);


// register VueFusionCharts component
Vue.use(VueFusionCharts, FusionCharts, Maps, World, FusionTheme)

library.add(faUserSecret)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('apexchart', VueApexCharts)

Vue.component('layout-login', Login);
Vue.component('layout-application', Application);

Vue.use(ReactiveSearch)
Vue.use(VueCookies)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  api,
  vuetify,
  render: h => h(App)
}).$mount('#app')
